export type RedirectRule = {
  target: string;
  status: number;
  pathRegExp: string;
};

// Fallback for retired marketing pages without an existing country-specific redirect.
export const retiredLandingRedirects: RedirectRule[] = [
  '^/how-talenthub-works/?$',
  '^/recruitment/?$',
  '^/managed-talent/?$',
  '^/job-search/?$',
  '^/fee-structure/?$',
  '^/talent-pool/?$',
  '^/startup-offer/?$',
  '^/remote-hiring/?$',
  '^/book-a-call/?$',
  '^/claim-startup-offer/?$',
  '^/events/?$',
  '^/ebooks(?:/.*)?$',
  '^/faq/?$',
  '^/success-stories(?:/.*)?$',
  '^/best-employers-award(?:/.*)?$',
  '^/enterprise/?$',
  '^/hiring-guide(?:/.*)?$',
  '^/solutions(?:/.*)?$',
  '^/interview-guideline/?$',
  '^/survey-karyawan/?$',
  '^/surat-kontrak-kerja/?$',
  '^/surat-keterangan-kerja/?$',
  '^/BD-job-description/?$',
  '^/SOP-rekrutmen/?$',
  '^/Kontrak-PKWTT/?$',
  '^/Kontrak-PKWT/?$',
  '^/360-degree/?$',
  '^/surat-peringatan/?$',
  '^/surat-penawaran/?$',
  '^/surat-penolakan/?$',
  '^/offering-letter/?$',
  '^/onboarding-karyawan/?$',
  '^/contoh-lowongan/?$',
  '^/employee-cost-calculator/?$',
].map(pathRegExp => ({
  pathRegExp,
  target: 'https://talenthub.glints.com',
  status: 301,
}));

// Preserve the original Singapore /404 destinations and exact URL matches.
const singaporeNotFoundRedirects: RedirectRule[] = [
  '^/how-talenthub-works$',
  '^/hiring-guide$',
  '^/hiring-guide/indonesia$',
  '^/hiring-guide/malaysia$',
  '^/hiring-guide/philippines$',
  '^/hiring-guide/singapore$',
  '^/hiring-guide/taiwan$',
  '^/hiring-guide/vietnam$',
  '^/success-stories$',
  '^/success-stories/luce-maintenance-group$',
  '^/success-stories/quokka-hr$',
  '^/success-stories/tripla$',
  '^/success-stories/revcomm$',
  '^/success-stories/tutor-circle$',
  '^/success-stories/two-alpha$',
  '^/success-stories/wizpresso$',
  '^/success-stories/travel-expert$',
  '^/success-stories/park-n-parcel$',
  '^/employee-cost-calculator$',
  '^/ebooks$',
  "^/ebooks/-greater-southeast-asia's-rising-tech-talent-pools$",
  '^/ebooks/southeast-asia-startup-talent-report-2023$',
  '^/ebooks/remote-hiring-for-startups/$',
  '^/recruitment$',
  '^/managed-talent$',
  '^/remote-hiring$',
  '^/fee-structure$',
  '^/startup-offer$',
  '^/talent-pool$',
  '^/job-search$',
].map(pathRegExp => ({
  pathRegExp,
  target: '/404',
  status: 301,
}));

const talentHubLandingRedirect: RedirectRule[] = [
  {
    pathRegExp: '^/$',
    target: 'https://talenthub.glints.com',
    status: 307,
  },
];

export const urlRedirectRules = {
  SG: [singaporeNotFoundRedirects],
  HK: [talentHubLandingRedirect],
  TW: [talentHubLandingRedirect],
} as const;

export const getLandingPageRedirect = (
  pathname: string,
  country?: string | null
): RedirectRule | undefined => {
  const countryRules =
    urlRedirectRules[country?.toUpperCase() as keyof typeof urlRedirectRules];
  const rules = [...(countryRules?.flat() || []), ...retiredLandingRedirects];
  return rules.find(rule => new RegExp(rule.pathRegExp).test(pathname));
};
